import { useEffect, useRef } from 'react';

const API_URL = import.meta.env.VITE_API_URL || '';

interface SSENotification {
  type: string;
  title: string;
  message: string;
  id?: number;
}

export function useSSE(onNotification: (data: SSENotification) => void) {
  const callbackRef = useRef(onNotification);
  callbackRef.current = onNotification;

  useEffect(() => {
    const token = localStorage.getItem('grant_crm_token');
    if (!token) return;

    let eventSource: EventSource | null = null;
    let retryTimeout: ReturnType<typeof setTimeout>;

    function connect() {
      const url = `${API_URL}/api/dashboard/sse?token=${encodeURIComponent(token!)}`;
      eventSource = new EventSource(url);

      eventSource.addEventListener('notification', (event) => {
        try {
          const data = JSON.parse(event.data);
          callbackRef.current(data);
        } catch { /* ignore parse errors */ }
      });

      eventSource.onerror = () => {
        eventSource?.close();
        retryTimeout = setTimeout(connect, 15000);
      };
    }

    connect();

    return () => {
      eventSource?.close();
      clearTimeout(retryTimeout);
    };
  }, []);
}
